window.contactValidationTwMessage = {
    ask_the_topic: {
        required: "このフィールドは必須です。",
    },
    content: {
        required: "このフィールドは必須です。",
        maxlength: "文字数制限を超えています。",
    },
    name: {
        required: "このフィールドは必須です。",
        maxlength: "文字数制限を超えています。",
    },
    company_name: {
        maxlength: "文字数制限を超えています。",
    },
    address: {
        maxlength: "文字数制限を超えています。",
    },
    email: {
        required: "このフィールドは必須です。",
        email: "メールアドレスを入力してください。",
        maxlength: "文字数制限を超えています。",
    },
    tel: {
        maxlength: "文字数制限を超えています。",
        tel: "電話番号を入力してください。",
    },
    privacy: {
        required: "プライバシーポリシーに同意するには、チェックしてください。",
    },
};
